// extracted by mini-css-extract-plugin
module.exports = {"default-arrows-container":"_02712f2b3b--default-arrows-container--Vy8RU","default-arrows-wrapper":"_02712f2b3b--default-arrows-wrapper--T4sQF"};